import { render, staticRenderFns } from "./Buy_detail.vue?vue&type=template&id=810c7958&scoped=true"
import script from "./Buy_detail.vue?vue&type=script&lang=js"
export * from "./Buy_detail.vue?vue&type=script&lang=js"
import style0 from "./Buy_detail.vue?vue&type=style&index=0&id=810c7958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c7958",
  null
  
)

export default component.exports